import styled from 'styled-components';

var HotelHitLink = styled.a.withConfig({
  displayName: "hotelHitLink__HotelHitLink",
  componentId: "sc-190xid0-0"
})(["bottom:0;left:0;position:absolute;right:0;top:0;"]);

export { HotelHitLink };
//# sourceMappingURL=hotelHitLink.js.map
